import React from "react";
import { Stack, Typography, alpha } from "@mui/material";
import colors from "../../assets/theme/colors";

const KnowledgeProfileItemGroups = ({
  handbook,
  showGroupHeadings = false,
  renderEntry,
}) => (
  <>
    {(handbook?.groups || []).map((group) => (
      <Stack key={group.id} spacing={0.15}>
        {showGroupHeadings && group.title ? (
          <Typography sx={{
            mt: 0.8,
            color: alpha(colors.semantic.ink2, 0.68),
            fontSize: "0.76rem",
            fontWeight: 500,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
          }}>
            {group.title}
          </Typography>
        ) : null}
        {(group.entries || []).map(renderEntry)}
      </Stack>
    ))}
  </>
);

export default KnowledgeProfileItemGroups;
